import { observer } from "mobx-react-lite"
import { Button, Modal } from "semantic-ui-react"
import DynamicTableFrontEnd from "../../DynamicTable/DynamicTableFrontEnd";
import { Dispatch, SetStateAction } from "react";

interface Props  {
    CutlistDetails:any[];
    viewShotsModel:boolean,
    setviewShotsModel:Dispatch<SetStateAction<boolean>>;
}
const CutlistPreviewModal = ({CutlistDetails,viewShotsModel,setviewShotsModel}:Props) => {
  return (
    <Modal
    style={{ width: '100%',height: '800px'}}
    onOpen={() => setviewShotsModel(true)}
    open={viewShotsModel}
    className="momentview-modal"
  >
    <Modal.Header>View Shots</Modal.Header>
    <Modal.Content style = {{height:'650px',display:'flex',justifyContent: 'center'}}>
    <DynamicTableFrontEnd
      data={CutlistDetails?.map((item: any) => Object.fromEntries(Object.entries(item).map(([key, value]: [string, any]) => [key, value.toString()])))}
      name={'viewShots'}
      actiontype={''}
    />
    </Modal.Content>
    <Modal.Actions>
      <Button
        color="black"
        onClick={() => setviewShotsModel(false)}
      >
        Close
      </Button>
    </Modal.Actions>
  </Modal>
  )
}

export default observer(CutlistPreviewModal)

